//export const BASE_API_URL = "http://54.169.131.81/tour/api/public/api";
export const BASE_API_URL = "https://api.trinitytrip.com/api";
